import React, { FC } from 'react';
//import './styles.css';

const Breadcrumbs: FC<{ examdata: any }> = ({ examdata }) => {
    
    return (
        <div className="breadcrumbs">	
            <div className="container" >
            <ol>
                <li><a href="/" className="active blue-color">Home</a> </li>
                <li><a href="/exams" className="active blue-color">Exams</a> </li>
                <li><a href="">{examdata.exam_title}</a></li>
            </ol>
            </div>
	    </div>
    );
};

export default Breadcrumbs;